import { Component, OnInit,Output,EventEmitter } from '@angular/core';
import { Route, Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { UserService } from '../../shared/user.service';
declare var $: any;
@Component({
  selector: 'app-level1menu',
  templateUrl: './level1menu.component.html',
  styleUrls: ['./level1menu.component.css']
})
export class Level1menuComponent implements OnInit {

  @Output() change = new EventEmitter();
  menuList:any;
  selectedItem:any;
  UserName:any;
  showMod:boolean=false;
  notification;  
  projnotification;

  constructor(private router: Router,private errorHandler:ErrorHandler,private userService: UserService) { }

  ngOnInit() {

    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    this.UserName=localStorage.getItem('userName');
    let selectedMenuId=localStorage.getItem('selectedMenu');
    if(selectedMenuId !=null && selectedMenuId != '' && typeof(selectedMenuId)!=undefined)
      this.selectedItem=selectedMenuId;
    else{
      if(this.menuList.length!=0)
        this.selectedItem=this.menuList[0].KM_MenuId;
    }  
    this.GetNotificationPopup();
    this.GetProjNotification();
  }

  listClick(event, newValue) {
    localStorage.setItem('selectedMenu',newValue);  
    this.selectedItem = newValue;  
}


GetNotificationPopup() {
  document.getElementById('loader-spinner').style.display = "block";
  this.userService.GetNotificationPopup() 
    .subscribe(
      (data:any) => {
        this.notification = data;
        if(this.notification!=0){$("#myModal").modal('show');}
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
}

GetProjNotification() {
document.getElementById('loader-spinner').style.display = "block";
this.userService.GetProjNotification() 
  .subscribe( 
    (data:any) => {
      this.projnotification = data;
       if(this.projnotification!=0){$("#myModal").modal('show');}
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });
}

  Logout(){
    localStorage.clear();
    this.change.emit(true);
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// ./src/app/common/level1menu/level1menu.component.ts